import React from 'react';

import { StaticImage } from 'gatsby-plugin-image';

import GLOBALS from 'app-globals';
import { Button, Heading, Icon, IconButton, Text } from 'components';
import { BUTTON_VARIANTS } from 'components/Button/constants';
import { HEADING_SIZES } from 'components/Heading/constants';
import { ICON_SIZES } from 'components/Icon/constants';
import {
  ICON_BUTTON_SIZES,
  ICON_BUTTON_VARIANTS,
} from 'components/IconButton/constants';
import useBreakpointValue from 'hooks/useBreakpointValue';

import * as styles from './styles.module.scss';

function TutorialLink({ label, link }) {
  const image = label.includes('teachers') ? (
    <StaticImage src="../../../images/tutorials/teachers.png" />
  ) : (
    <StaticImage src="../../../images/tutorials/students.png" />
  );

  const textType = useBreakpointValue({
    base: HEADING_SIZES.MD,
    sm: HEADING_SIZES.XS,
  });

  return (
    <div className={styles.card}>
      {image}
      <div className={styles.info}>
        <div className={styles.text}>
          <Text colorClass={GLOBALS.COLOR_CLASSES.NEUTRAL['400']}>
            CODECHUM HELP CENTER
          </Text>
          <Heading size={textType}>{label}</Heading>
        </div>
        <a href={link} rel="noreferrer" target="_blank">
          <Button
            className={styles.button___desktop}
            rightIcon={<Icon name="launch" size={ICON_SIZES.SM} />}
            variant={BUTTON_VARIANTS.GHOST}
          >
            View
          </Button>
        </a>
        <IconButton
          className={styles.button___mobile}
          colorName={GLOBALS.COLOR_NAMES.BLUE}
          icon={<Icon name="launch" size={ICON_SIZES.XL} />}
          size={ICON_BUTTON_SIZES.XL}
          variant={ICON_BUTTON_VARIANTS.SUBTLE}
        />
      </div>
    </div>
  );
}

export default TutorialLink;
